<template>
  <v-container fluid>
    <!-- Filtro de Despesas! -->
    <v-layout row wrap justify-center>
      <v-flex md12 xs12 class="ma-0 pa-0">
        <div class="text-xs-center">
          <component-filtro-avancado
            :ehUsuarioAprovador="ehUsuarioAprovador"
            :filtro="filtroDespesas"
            :viewAtual="listarReembolsoDoUsuario"
            :page="page"
            telaAtual="PagamentoColaborador"
          ></component-filtro-avancado>
        </div>
      </v-flex>
    </v-layout>

    <v-card>
      <v-card-title class="blue-grey lighten-2 white--text" style="font-size: 20px;">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="itensSelecionados <= 0 || loadingRequests"
          v-if="usuarioAutenticado.papeis.filter(papel => papel.nome === 'PROCURADOR').length > 0"
          small
          @click="aprovarPagamentos()"
          color="primary"
        >Aprovar Pagamentos</v-btn>
      </v-card-title>
    </v-card>

    <v-data-table
      item-key="index "
      hide-actions
      :items="reembolsos.content"
      :headers="titulosTabela"
      :loading="loadingRequests"
      :page.sync="page"
      :pagination.sync="pagination"
      class="text-md-center"
    >
      <template slot="items" slot-scope="props">
        <td
          v-if="usuarioAutenticado.papeis.filter(papel => papel.nome === 'PROCURADOR').length > 0"
        >
          <v-checkbox
            v-model="props.item.selecionado"
            v-if="props.item.status === 'ENVIADO_PARA_PROCURADOR'"
            class="checkbox-lista"
          ></v-checkbox>
        </td>
        <td>{{ props.item.fornecedor }}</td>
        <td>{{ props.item.empresa }}</td>
        <td>{{ props.item.numeroDoPedido }}</td>
        <td>{{ formataData(props.item.cadastro)}}</td>
        <td>{{ formataData(props.item.vencimento)}}</td>
        <td>{{ converteParaMoedaReal(props.item.valor, props.item.tipoDeMoeda) }}</td>
        <td>{{ props.item.tipo == 'PrestacaoDeContas' ? 'Prestação de Contas' : props.item.tipo}}</td>
        <td>{{ props.item.solicitante}}</td>
        <td v-html="retornaStatus(props.item.status)"></td>
        <td class="text-xs-center">
          <v-tooltip bottom class="paddingTooltip">
            <v-icon
              small
              class="mr-2"
              slot="activator"
              @click="visualizarPedido(props.item)"
            >visibility</v-icon>

            <span>Visualizar</span>
          </v-tooltip>
          <v-tooltip bottom class="paddingTooltip">
            <v-icon
              small
              class="mr-2 text-xs-right"
              slot="activator"
              v-if="usuarioAutenticado.id == props.item.solicitanteId
              && props.item.status.indexOf('REPROVADO') > -1"
              @click="dialogExcluir = true; idParaExcluir = props.item.id; tipoParaExcluir = props.item.tipo;"
            >delete</v-icon>
            <span>Deletar solicitação</span>
          </v-tooltip>
        </td>
      </template>
      <template slot="no-data">
        <p class="text-xs-center" style="margin: 0; padding: 0">{{ textoNaoEncontrado }}</p>
      </template>
      <template slot="headers" slot-scope="props">
        <tr>
          <th :colspan="titulosTabela.length">
            <v-layout justify-center>
              <v-flex align-self-center class="text-center">
                <p class="title font-weight-bold mt-3" style="color: #005ca3">
                  Total:
                  <span class="soma-valores">{{converteParaMoedaReal(totalLiquido)}}</span>
                </p>
              </v-flex>
            </v-layout>
          </th>
        </tr>
        <tr>
          <th
            v-if="usuarioAutenticado.papeis.filter(
        papel => papel.nome === 'PROCURADOR'
      ).length > 0"
          >
            <v-checkbox
              :disabled="temPedidosParaProcurador || loadingRequests"
              v-model="selecionado"
              hide-details
              @change="selecionarTodos()"
            ></v-checkbox>
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[header.sortable ? 'column sortable': '', 'text-left', 'pr-4 pl-2', pagination.descending ? 'asc' : 'desc', titulosTabela.value === pagination.sortBy ? 'active' : '']"
            @click="trocarOrdenamentoDaLista(header.value)"
          >
            <v-icon
              small
              color="black"
              v-if="!pagination.descending && header.sortable == true"
            >arrow_upward</v-icon>
            <v-icon
              small
              color="black"
              v-if="pagination.descending && header.sortable == true"
            >arrow_downward</v-icon>
            {{header.text}}
          </th>
        </tr>
      </template>
    </v-data-table>

    <v-dialog
      @keydown.esc="dialogExcluir = false"
      v-model="dialogExcluir"
      max-width="550px"
      color="error"
    >
      <v-card class="error darken-4" style="padding:20px">
        <v-card-title style="padding: 0px">
          <p class="messageSelectPaymentType">Tem certeza que deseja excluir esta solicitação?</p>
        </v-card-title>
        <v-card-text style="padding: 0px">
          <v-layout row wrap>
            <v-flex xs12 style="text-align:center">
              <v-btn
                ripple
                style="font-weight: bold"
                @click="deletarSolicitacao(idParaExcluir, tipoParaExcluir)"
              >Sim</v-btn>
              <v-btn ripple style="font-weight: bold" @click="dialogExcluir = false">Não</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="text-xs-center" v-if="reembolsos.totalPages > 0">
      <v-pagination v-model="page" :length="reembolsos.totalPages" :total-visible="30"></v-pagination>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
import FiltroAvancado from "./FiltroAvancado";
import { bus } from "../../main";
import moedasMixins from "../../mixins/moedasMixin";

export default {
  data() {
    return {
      idParaExcluir: null,
      tipoParaExcluir: null,
      selecionado: false,
      loadingRequests: false,
      dialogExcluir: false,
      quantidadeDeItens: 0,
      page: 1,
      pagination: {
        sortBy: "empresa",
        descending: false,
        rowsPerPage: 100,
      },
      titulosTabela: [
        {
          text: "Fornecedor",
          value: "fornecedor",
          sortable: true,
          align: "left",
        },
        { text: "Empresa", value: "empresa", sortable: true, align: "left" },
        {
          text: "Nº do Pedido",
          value: "numeroDoPedido",
          sortable: true,
          align: "left",
        },
        { text: "Cadastro", value: "cadastro", sortable: true, align: "left" },
        {
          text: "Vencimento",
          value: "vencimento",
          sortable: true,
          align: "left",
        },
        { text: "Valor", value: "valor", sortable: true, align: "left" },
        { text: "Tipo", value: "tipo", sortable: true, align: "left" },
        {
          text: "Solicitante",
          value: "solicitante",
          sortable: true,
          align: "center",
        },
        { text: "Status", value: "status", sortable: false, align: "center" },
        { text: "Ações", sortable: false, align: "center" },
      ],
      reembolsos: [],

      textoNaoEncontrado: "Não há solicitações cadastradas.",

      modalFiltroDespesasStatus: null,
      modalFiltroDespesasDataInicio: false,
      modalFiltroDespesasDataFinal: false,
      //Filtros!
      filtroDespesas: {
        idDoUsuarioAprovador: "",
        idDoUsuarioRegistrador: "",
        status: "",
        nomeOuCpfOuCnpj: "",
        idDaEmpresa: "",
        idDoCentroDeCusto: "",
        idDaContaGerencial: "",
        numeroDoPedido: "",
        solicitante: "",
        dataEmissaoInicio: "",
        dataEmissaoFim: "",
        dataVencimentoInicio: "",
        dataVencimentoFim: "",
        valorInicio: "R$ 0,00",
        valorFinal: "R$ 0,00",
        pagamentoComExcecao: false,
      },
      loadingStatus: false,
      regraDataBusca: [(date) => !!date || "Data é obrigatória."],
      servico: "",
      totalLiquido: 0.0,
    };
  },
  components: {
    componentFiltroAvancado: FiltroAvancado,
  },
  props: ["ehUsuarioAprovador", "listarReembolsoDoUsuario"],
  computed: {
    usuarioAutenticado() {
      return this.$store.getters.usuarioAutenticado;
    },
    temPedidosParaProcurador() {
      if (this.reembolsos.content == undefined) return true;
      let temPedidos =
        this.reembolsos.content.filter(
          (i) => i.status == "ENVIADO_PARA_PROCURADOR"
        ).length > 0;
      if (temPedidos) return false;
      else return true;
    },
    itensSelecionados() {
      if (this.reembolsos.content != undefined)
        return this.reembolsos.content.filter((i) => i.selecionado == true)
          .length;
      else return 0;
    },
    listaDeStatus() {
      return this.$store.state.listaDeStatus;
    },
  },
  watch: {
    "page"(pagina) {
      this.filtarPedidosDeColaborador(pagina);
    },
    async "listarReembolsoDoUsuario.nome"(textoDoBotao) {
      await this.filtrarDespesas(1);
    },
    "reembolsos.content"() {
      this.somarTotalLiquido();
    },
  },
  methods: {
    async deletarSolicitacao(id, tipo) {
      this.dialogExcluir = false;
      this.loadingRequests = true;
      await axios({
        method: "delete",
        url: `/pedidos/${id}/tipo/${tipo}`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioAutenticado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((resposta) => {
          this.$store.commit("snackSucesso", "Pedido excluido.");
        })
        .catch((e) =>
          this.$store.commit(
            "snackSucesso",
            "Houve um erro na aprovação dos pagamentos."
          )
        )
        .finally((erro) => {
          this.loadingRequests = false;
          this.selecionado = false;
          this.recarregarDados();
        });
    },
    trocarOrdenamentoDaLista(coluna) {
      if (this.pagination.sortBy === coluna) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = coluna;
        this.pagination.descending = false;
      }
    },
    retornaStatus(statusRecebido) {
      let classe = "";
      let nome = "";
      this.listaDeStatus.map((i) => {
        if (i.valor == statusRecebido) {
          nome = i.nome;
          classe = i.classe;
        }
      });
      return `<p class="${classe} pt-2">${nome}</p>`;
    },
    async selecionarTodos() {
      let copiaPedidos = this.reembolsos.content;
      for (let index = 0; index < copiaPedidos.length; index++) {
        const element = copiaPedidos[index];
        if (element.status == "ENVIADO_PARA_PROCURADOR")
          element.selecionado = this.selecionado;
      }
      this.reembolsos.content = await copiaPedidos;
    },
    recarregarDados() {
      bus.$emit("carregarDados", 1);
    },
    async aprovarPagamentos() {
      this.loadingRequests = true;
      let itens = this.reembolsos.content.filter((i) => i.selecionado == true);
      let apenasIds = itens.map((i) => i.id);

      let objEnvio = {
        idDoAprovador: this.usuarioAutenticado.id,
        solicitacoes: apenasIds,
      };
      this.$store.commit("snackLoading", "Aprovando pagamentos...");

      axios({
        method: "PATCH",
        url: `/pedidos`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioAutenticado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: JSON.stringify(objEnvio),
      })
        .then((resposta) => {
          this.$store.commit("snackSucesso", "Pagamentos aprovados");
        })
        .catch((e) =>
          this.$store.commit(
            "snackSucesso",
            "Houve um erro na aprovação dos pagamentos."
          )
        )
        .finally((erro) => {
          this.loadingRequests = false;
          this.selecionado = false;
          this.recarregarDados();
        });
    },
    async inicializa() {},
    visualizarPedido(item) {
      const { tipo } = item;
      const { id } = item;
      if (tipo === "Adiantamento")
        this.$router.push({ path: `/pedidos/adiantamentos/${id}` });

      if (tipo === "Reembolso")
        this.$router.push({ path: `/pedidos/reembolsos/${id}` });

      if (tipo === "PrestacaoDeContas")
        this.$router.push({ path: `/pedidos/prestarcontas/${id}` });
    },
    formataData(data) {
      if (data != null) {
        let [ano, mes, dia] = data.split("T")[0].split("-");
        return `${dia}/${mes}/${ano}`;
      }
    },
    converteParaMoedaReal(numero, formatoDaMoeda) {
      let formatter;
      if (formatoDaMoeda == "USD")
        formatter = this.converterOutrasMoedas("en-US", "currency", "USD");
      else if (formatoDaMoeda == "AUD")
        formatter = this.converterOutrasMoedas("en-au", "currency", "AUD");
      else if (formatoDaMoeda == "CAD")
        formatter = this.converterOutrasMoedas("en-ca", "currency", "CAD");
      else if (formatoDaMoeda == "JPY")
        formatter = this.converterOutrasMoedas("ja", "currency", "JPY");
      else if (formatoDaMoeda == "EUR")
        formatter = this.converterOutrasMoedas("fr", "currency", "EUR");
      else if (formatoDaMoeda == "GBP")
        formatter = this.converterOutrasMoedas("en-gb", "currency", "GBP");
      else if (formatoDaMoeda == "SGD")
        formatter = this.converterOutrasMoedas("zh-sg", "currency", "SGD");
      else if (formatoDaMoeda == "MXN")
        formatter = this.converterOutrasMoedas("es-mx", "currency", "MXN");
      else formatter = this.converterOutrasMoedas("pt-BR", "currency", "BRL");
      return formatter.format(numero);
    },
    converterOutrasMoedas(linguagem, estilo, pais) {
      return new Intl.NumberFormat(linguagem, {
        style: estilo,
        currency: pais,
        minimumFractionDigits: 2,
      });
    },
    somarTotalLiquido() {
      this.totalLiquido = 0.0;
      for (let i = 0; i < this.reembolsos.content.length; i++) {
        if (this.reembolsos.content[i].tipoDeMoeda == "BRL") {
          this.totalLiquido += this.reembolsos.content[i].valor;
        }
      }
    },
    async filtarPedidosDeColaborador(pagina) {
      this.$store.commit("set", {
        itemName: "loadingRequests",
        content: true,
      });
      let urlFiltro = "/pedidos/busca?";
      let filtroIdUsuarioAprovador = "idDoUsuarioAprovador=";
      let filtroIdUsuarioRegistrador = "idDoUsuarioRegistrador=";
      if (
        this.ehUsuarioAprovador &&
        this.listarReembolsoDoUsuario.nome === "Solicitações dos Usuários"
      ) {
        filtroIdUsuarioAprovador = `${filtroIdUsuarioAprovador}${this.$store.state.loggedUser.id}`;
      } else {
        filtroIdUsuarioRegistrador = `${filtroIdUsuarioRegistrador}${this.$store.state.loggedUser.id}`;
      }
      for (let i in this.filtroDespesas) {
        if (this.filtroDespesas[i] == undefined) {
          this.filtroDespesas[i] = "";
        }
      }
      urlFiltro = `${urlFiltro}${filtroIdUsuarioAprovador}&${filtroIdUsuarioRegistrador}&status=${
        this.filtroDespesas.status
      }&empresa=${this.filtroDespesas.idDaEmpresa}&numeroDoPedido=${
        this.filtroDespesas.numeroDoPedido
      }&centroDeCusto=${this.filtroDespesas.idDoCentroDeCusto}&contaGerencial=${
        this.filtroDespesas.idDaContaGerencial
      }&solicitante=${this.filtroDespesas.solicitante}&dataVencimentoInicio=${
        this.filtroDespesas.dataVencimentoInicio
      }&dataVencimentoFim=${
        this.filtroDespesas.dataVencimentoFim
      }&valorInicio=${parseFloat(
        this.converterValorStringEmNumero(this.filtroDespesas.valorInicio, "BRL").trim()
      )}&valorFinal=${parseFloat(
        this.converterValorStringEmNumero(this.filtroDespesas.valorFinal, "BRL").trim()
      )}&nomeOuCpfOuCnpj=${this.filtroDespesas.nomeOuCpfOuCnpj
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "")}&pagamentoComExcecao=${
        this.filtroDespesas.pagamentoComExcecao
      }&pagina=${pagina - 1}`;
      localStorage.setItem(
        "camposSolicitacaoPedidos",
        JSON.stringify(this.filtroDespesas)
      );
      await this.fazerRequest(urlFiltro)
        .then((resposta) => {
          resposta.data.content.map((p) => (p.selecionado = false));
          bus.$emit("reembolsosFiltrados", resposta.data);
        })
        .catch((e) => {
          bus.$emit("reembolsosFiltrados", []);
        });
      this.dialog = false;
    },
    async fazerRequest(url) {
      return await axios({
        method: "get",
        url: `${url}`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.$store.state.loggedUser.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then(function (response) {
          return response;
        })
        .finally((s) => {
          this.$store.commit("set", {
            itemName: "loadingRequests",
            content: false,
          });
        });
    },
  },
  mixins: [moedasMixins],
  async created() {
    bus.$on("reembolsosFiltrados", (reembolsos) => {
      this.reembolsos = reembolsos;
    });
    await this.inicializa();
  },
};
</script>
<style scoped>
.soma-valores {
  font-weight: bold;
  color: #ff0d7b !important;
  width: 60% !important;
  font-size: 21px !important;
}
.messageSelectPaymentType {
  font-size: 20px;
  color: white;
  margin: auto;
  text-align: center;
}
</style>